<!-- Submitted is checked first: the window moves with the lesson, so a reschedule can push a lesson
	past its own opening again — an answered survey must stay readable regardless. -->
@if (isSubmitted()) {
	<button md-button (click)="action.emit()">View Response</button>
} @else if (!isAvailable()) {
	<span class="survey-action__unavailable md-text-xs-regular">Not yet available</span>
} @else if (canSubmit()) {
	<button md-button-brand (click)="action.emit()">Start Reflection</button>
} @else {
	<span class="survey-action__pending md-text-xs-regular">Not yet submitted</span>
}
